// extracted by css-extract-rspack-plugin
export default {"banner":"Vb0Jkc34vYphlNZo","heading":"uvdsKqxesBULFlXd","description":"VlUdi5SpEZwt_csL"};